module.exports = __webpack_public_path__ + "static/yt_ats-09299329255d58bef46f5f1c6e63c768.png";